import MenuItemImage from "./MenuItemImage";
import { formatCurrency } from "../../utils/formatters";

function MenuItemCard({ item, actionLabel = "Add to Cart", onAdd }) {
  const isSoldOut = Boolean(item.sold_out);

  return (
    <article className={`food-card public-food-card${isSoldOut ? " is-sold-out" : ""}`}>
      <MenuItemImage item={item} />
      <div className="food-card-body">
        <div className="food-card-meta">
          <span className="badge badge-muted">{item.category?.name || "Favorite"}</span>
          {item.weekly ? <span className="badge badge-weekly">Weekly</span> : null}
          {isSoldOut ? <span className="badge badge-sold-out">Sold Out</span> : null}
        </div>

        <div>
          <h3>{item.name}</h3>
          {item.description ? <p className="muted-text">{item.description}</p> : null}
        </div>

        {item.special_note ? <p className="public-note">{item.special_note}</p> : null}

        <div className="public-food-card-footer">
          <span className="price-display">{formatCurrency(item.price || item.base_price)}</span>
          <button
            className="btn btn-primary btn-sm"
            disabled={isSoldOut}
            onClick={() => onAdd?.(item)}
            type="button"
          >
            {isSoldOut ? "Sold Out" : actionLabel}
          </button>
        </div>
      </div>
    </article>
  );
}

export default MenuItemCard;